module.exports = __webpack_public_path__ + "img/newercodeen.976a3931.jpg";